(function () {
	Vue.component('nominow-input-switch', {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
			},
			label: {
				type: String,
				required: true,
				default: 'Label'
			},
			label2: {
				type: String,
				required: true,
				default: 'Label2'
			},
			name: {
				type: String,
				required: false
			},
			css: {
				type: String,
				required: false
			}
		},
		template: `
            <div class="control field text-in-switch">
                <label class="switch">
                    <input type="checkbox" :value="value" :checked="value" v-on:change="$emit('change', $event.target.checked)" :class="css" :name="name || label"  />
                    <span class="knob">
                    <span class="subject">{{label2}}</span>
                        <span class="subject">{{label}}</span>
                    </span>
                </label>
            </div>
        `
	});
})();

{
	/* <div class="control field filter-switch-field">
<label class="switch">
    <input type="checkbox" :value="value" :checked="value" v-on:change="$emit('change', $event.target.checked)" :class="css" :name="name || label"  />
    <span class="knob"></span>
    <span class="subject">{{label}}</span>
    <span class="subject">{{label2}}</span>
</label>
</div> */
}
